/* Casualty screens (docs/plans/phase2-casualty.md §5): the Casualty page, identifying a
 * patient and record merges. Tokens only; the components come from packages/ui. */

.page {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
  min-width: 0;
}

.meta {
  margin: 0;
  color: var(--graphite);
  font: var(--t-small);
}

.queues {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  margin: 0;
  padding: 0;
  list-style: none;
}

.queue {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3);
  align-items: baseline;
  justify-content: space-between;
  min-height: 2.75rem;
  padding: var(--space-2) 0;
  border-bottom: 1px solid var(--border);
}

.queue:last-child {
  border-bottom: 0;
}

.queueName {
  color: var(--ink);
  font: var(--t-body-strong);
}

/* A temporary label is an identifier: the mono face (DESIGN.md §3). */
.label {
  font-family: var(--font-id);
}

.form {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3);
}

.side {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(22rem, 1fr));
  gap: var(--space-4);
}

.sideTitle {
  margin: 0 0 var(--space-2);
  font: var(--t-body-strong);
}

.facts {
  margin: 0;
  padding-left: var(--space-5);
}

.requests {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  margin: 0;
  padding: 0;
  list-style: none;
}

.request {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3);
  align-items: baseline;
  justify-content: space-between;
  min-height: 2.75rem;
  padding: var(--space-2) 0;
  border-bottom: 1px solid var(--border);
}
